'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minute;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minute.js
// module id = 703
// module chunks = 0